import { render } from "./ContactEditDialog.vue?vue&type=template&id=246fb633&scoped=true"
import script from "./ContactEditDialog.vue?vue&type=script&lang=js"
export * from "./ContactEditDialog.vue?vue&type=script&lang=js"

import "./ContactEditDialog.vue?vue&type=style&index=0&id=246fb633&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-246fb633"]])

export default __exports__